import { render } from "./App.vue?vue&type=template&id=91c1502a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=91c1502a&lang=css"

import exportComponent from "C:\\laz\\vue\\Real-World_Vue-3\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__